import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupEventsApi } from '@/features/api/hooks/grapevine-group-events/useGrapevineGroupEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useLeaveGroup = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineGroupEventsApi();

  return useApiMutation({
    mutationFn: (groupId: string) =>
      api.leaveGroup({ clientGroupLeaveRequest: { groupId } }),
    onSuccess: ({ group }) => {
      queryClient.setQueriesData(
        { queryKey: [API_CACHE_KEYS.GROUP, group.id] },
        () => group
      );
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.GROUPS] });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.GROUP_MEMBERS, group.id]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.GROUP_ADMINS, group.id]
      });
    }
  });
};
